import { FileDto } from '../dto'
import { File } from '../models/'
import { MimeType } from '@e3dc-react/shell/Types'

export const fromFileDtoToModel = (data: FileDto[]): File[] =>
  data.map(elem => ({
    id: elem.id ?? 0,
    createdAt: elem.createdAt ?? '',
    name: elem.name ?? '',
    type: elem.type ?? 'warranty',
    s3FileName: elem.s3FileName ?? '',
    mimeType: (elem.mimeType as MimeType) ?? 'application/pdf',
    extension: elem.extension ?? '',
    size: elem.size ?? 0,
  }))
